export default __webpack_public_path__ + "static/autocovers-37b55bc776f013311eda89bac2d5c61b.jpg";